// src/redux/slices/hashtagSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { getHashTags } from '../apis/getHashTags';

// Async thunk to fetch hashtag data
export const fetchHashTagData = createAsyncThunk(
    'hashtag/fetchHashTagData',
    async (_, { rejectWithValue }) => {
        try {
            const data = await getHashTags();
            return data;
        } catch (error) {
            return rejectWithValue(error.response?.data || error.message);
        }
    },
    {
        condition: (_, { getState }) => {
            const { loading, loaded } = getState().hashtag;
            return !loading && !loaded;
        },
    }
);

const hashtagSlice = createSlice({
    name: 'hashtag',
    initialState: {
        loading: false,
        loaded: false,
        data: null,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchHashTagData.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchHashTagData.fulfilled, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.data = action.payload;
            })
            .addCase(fetchHashTagData.rejected, (state, action) => {
                state.loading = false;
                state.loaded = true;
                state.error = action.payload || 'Something went wrong';
            });
    },
});

export default hashtagSlice.reducer;
